import React, { Component } from 'react';
import { Container, Row, Col, Input, Label } from 'reactstrap';
import './Demographics.css';
import 'bootstrap/dist/css/bootstrap.css';
import AdvisorView from '../../components/MasterChildDemographics/AdvisorView';
import CompanyContext from '../../auth/CompanyContext';
class MasterChildDemographics extends Component {
  static contextType = CompanyContext;

  constructor(props) {
    super(props);
    this.available_dates = props.available_dates;
    this.newID = String(this.props.location.pathname).split('/')[2];
    this.secID = '';
    this.orgID = 0;
    String(this.newID).split('_').forEach(item => {
      if (item.indexOf('-') === -1 && Number.isInteger(parseInt(item))) {
        this.orgID = item;
      } else if (item.indexOf('-') > -1) {
        this.secID = item;
      }
    })
    this.state = {
      currentDate: ("location" in this.props &&
        "state" in this.props.location && this.props.location.state != null &&
        "currentDate" in this.props.location.state &&
        this.props.location.state.currentDate != null)
        ? this.props.location.state.currentDate
        : this.props.available_dates[this.props.available_dates.length - 1].date_key,
      secID: this.secID,
      orgID: this.orgID,
      chartData: [],
      graphData: [],
      scaleAxesCheck: false
    };
  };


  componentDidMount() {
    this.setState(
      { loading: true },
      () => {
        this.getChartData(this.state.secID, this.state.currentDate);
        this.getGraphData(this.state.secID);
      }
    );

  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  handleDateInputChange = (e) => {
    e.persist();
    if (e.target.name === 'current_date') {
      this.setState({ loading: true, currentDate: e.target.value },
        () => { this.getChartData(this.state.secID, this.state.currentDate); }
      );
    }
  }

  handleScaleAxes = () => {
    const curCheck = this.state.scaleAxesCheck;
    this.setState({
      scaleAxesCheck: !curCheck
    })
  }

  getChartData(secID, currentDate) {
    fetch('/api/masterChildDemographicsCharts/' + secID + '/' + currentDate, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        this.setState({
          chartData: results.data
        });
      });
  }

  getGraphData(secID) {
    fetch('/api/masterChildDemographicsGraphs/' + secID, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        this.setState({
          graphData: results.data,
        });
      });
  }

  render() {
    if (this.state.chartData?.length > 0 && this.state.graphData?.length > 0) {
      return (
        <Container fluid={true}>
          <Container fluid={true} className="align-items-center fixed-bottom demographicsStickyTopPanel">
            <Row >
              <Col md={4} className="text-left pb-1  "><h2>Master/Child Advisors</h2></Col>
              <Col md="4" className="text-right pt-2  ">
                <Label><Input
                  type="checkbox"
                  name="current_date"
                  onChange={e => this.handleScaleAxes()}
                  checked={this.state.scaleAxesCheck}
                /> Scale Graphs to Total
                </Label>
              </Col>
              <Col md="2" className="text-right pt-2  "><Label>Set chart data period:</Label> </Col>
              <Col md="2" className="pt-2 ">
                <Input
                  type="select"
                  name="current_date"
                  onChange={e => this.handleDateInputChange(e)}
                  value={this.state.currentDate.substr(0, 2) + this.state.currentDate.substr(2, 2) + this.state.currentDate.substr(4, 2)}
                >
                  {this.props.available_dates.map(d => (
                    <option value={d.date_key} key={'current_date_' + d.date_string}>{d.date_string}</option>
                  ))}
                </Input>
              </Col>
            </Row>
          </Container>
          {this.state.chartData.map((advisor, index) => (
            <AdvisorView key={index}
              clientToken={this.props.clientToken}
              data={advisor}
              id={index}
              currentDate={this.state.currentDate}
              graphData={this.state.graphData[index]}
              handleDateInputChange={this.handleDateInputChange}
              available_dates={this.props.available_dates}
              master={(index === 1) ? true : false}
              scaleAxesAUM={this.state.scaleAxesCheck ? Math.max(...[...this.state.graphData[0]].map(item => item['AUM Total'])) : null}
              scaleAxesAccounts={this.state.scaleAxesCheck ? Math.max(...[...this.state.graphData[0]].map(item => item['Total Accounts'])) : null}
            />
          ))}
        </Container>
      )
    } else {
      return (
        <Container>
          <h1>Advisor Demographics</h1>
          <p>Loading...</p>
        </Container>
      );
    }
  }
}



export default MasterChildDemographics;
